<template>
    <b-breadcrumb class="simbar-breadcrumb">
        <b-breadcrumb-item
            v-for="(item, i) in breadcrumbs"
            :key="`breadcrumb-${i}`"
            :to="item.to"
            :active="i === breadcrumbs.length - 1"
            :class="{
                'd-sm-none d-block': !!item.middle,
                'd-none d-sm-block':
                    i > 0 && i < breadcrumbs.length - 1 && !!!item.middle,
                'simbar-breadcrumb-item': true
            }"
        >
            {{ item.text }}
        </b-breadcrumb-item>
    </b-breadcrumb>
</template>

<script>
export default {
    name: "SimbarBreadcrumb",
    computed: {
        breadcrumbs() {
            const matched = this.$route.matched.map(route => ({
                text: route.meta.title,
                to: { name: route.name }
            }));
            return [
                {
                    text: "Home",
                    to: { name: "home" }
                },
                {
                    text: "...",
                    middle: true
                }
            ].concat(matched);
        }
    }
};
</script>

<style lang="scss" scoped>
.simbar-breadcrumb.breadcrumb {
    background-color: inherit;
    margin-bottom: 0;

    .breadcrumb-item + .breadcrumb-item::before {
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        font-family: "Font Awesome 5 Free";
        content: "\f101";
        font-weight: 900;
        padding-right: 0.25rem;
        font-size: 0.875rem;
    }

    .breadcrumb-item.active {
        display: block;
    }

    a {
        text-decoration: none;
    }
}
</style>
